import { PixelDataToJSON } from './models/PixelData.js';
import { ToPixelList } from './models/PixelList.js';

class DisplayAlwaysPixelsApi {
    async getDisplayAlwaysPixels(requestParams) {
        const response = await this.request({
            path: `/om/nr/pxl/${requestParams.site}/${requestParams.type}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Caller': 'om-pixel-executor-lib',
            },
            query: { consent: requestParams.consent },
            body: PixelDataToJSON(requestParams.pixelData),
        }).catch((e) => console.error(e));
        return ToPixelList(response);
    }
    async request(context) {
        const { url, init } = await this.createFetchParams(context);
        let response = undefined;
        response = await fetch(url, init);
        if (response.status === 204) {
            return undefined;
        }
        if (response && response.status >= 200 && response.status < 300) {
            return response.json();
        }
        throw new Error(`[OMT] - API returned ${response.status} response status.`);
    }
    async createFetchParams(context) {
        let url = context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            url += `?consent=${encodeURIComponent(String(context.query.consent))}`;
        }
        const init = {
            method: context.method,
            headers: context.headers,
            body: JSON.stringify(context.body),
        };
        return { url, init };
    }
}

export { DisplayAlwaysPixelsApi };
//# sourceMappingURL=DisplayAlwaysPixelsApi.js.map
